import React from "react";



const BodySeparator = (props) =>  {
    const {
        width = "100%",
        marginTop ='0px',
        marginBottom = '0px',
        text,
        className = ''
    } = props;
    return(
      <div className={`flex w-[100%] items-center h-fit mt-[${marginTop}] mb-[${marginBottom}] ${className}`}>
        {
            text &&
            <div className='pr-[10px] text-white text-[13px] whitespace-nowrap'>
                {text}
            </div>
        }
            
          <div className={` w-[${width}] flex-shrink-1 h-[0.0625rem] rounded-lg bg-[#484848]`} />
        </div>
      
  
    )
}

export default BodySeparator;
